export const UI = {
  nav: {
    services: { en: "Services", es: "Servicios" },
    gallery: { en: "Our Work", es: "Nuestro Trabajo" },
    reviews: { en: "Reviews", es: "Reseñas" },
    contact: { en: "Contact", es: "Contacto" },
    quote: { en: "Free Quote", es: "Cotización Gratis" },
    callUs: { en: "Call Us", es: "Llámanos" },
    menu: { en: "Menu", es: "Menú" }
  },
  galleryFilters: {
    all: { en: "All", es: "Todo" },
    residential: { en: "Residential", es: "Residencial" },
    commercial: { en: "Restaurants & Commercial", es: "Restaurantes y Comercial" },
    custom: { en: "Custom Work", es: "Trabajo a Medida" }
  },
  contact: {
    name: { en: "Your name", es: "Tu nombre" },
    phone: { en: "Your phone", es: "Tu teléfono" },
    message: { en: "What do you need upholstered?", es: "¿Qué necesitas tapizar?" },
    send: { en: "Send Request", es: "Enviar Solicitud" },
    sending: { en: "Sending...", es: "Enviando..." },
    success: { en: "Request sent! We will call you soon.", es: "¡Solicitud enviada! Te llamaremos pronto." },
    error: { en: "Could not send. Please call us.", es: "No se pudo enviar. Por favor llámanos." },
    callNow: { en: "Call now", es: "Llama ahora" },
    whatsapp: { en: "WhatsApp", es: "WhatsApp" },
    hours: { en: "Business hours", es: "Horario" },
    area: { en: "Service area", es: "Área de servicio" },
    formTitle: { en: "Request a free quote", es: "Solicita una cotización gratis" }
  },
  calc: {
    eyebrow: { en: "Transparent pricing", es: "Precios claros" },
    title: { en: "Instant estimate in seconds", es: "Cotización instantánea en segundos" },
    pieces: { en: "Piece type", es: "Tipo de pieza" },
    quantity: { en: "Quantity", es: "Cantidad" },
    quality: { en: "Fabric quality", es: "Calidad de la tela" },
    standard: { en: "Standard fabric", es: "Tela estándar" },
    premium: { en: "Premium fabric", es: "Tela premium" },
    estimate: { en: "Estimated range", es: "Rango estimado" },
    request: { en: "Request this quote", es: "Solicitar esta cotización" },
    note: { en: "Free in-person assessment confirms the final price.", es: "La evaluación gratuita en persona confirma el precio final." }
  },
  ba: {
    eyebrow: { en: "Before & After", es: "Antes y Después" },
    title: { en: "See the transformation", es: "Mira la transformación" },
    before: { en: "Before", es: "Antes" },
    after: { en: "After", es: "Después" },
    drag: { en: "Drag to compare", es: "Arrastra para comparar" }
  },
  areas: {
    title: { en: "Areas we serve in New Jersey", es: "Áreas que servimos en Nueva Jersey" }
  },
  footer: {
    rights: { en: "All rights reserved.", es: "Todos los derechos reservados." },
    adminAccess: { en: "Owner access", es: "Acceso del dueño" }
  },
  admin: {
    login: { en: "Owner Login", es: "Acceso del Dueño" },
    email: { en: "Email", es: "Correo electrónico" },
    password: { en: "Password", es: "Contraseña" },
    enter: { en: "Sign in", es: "Iniciar sesión" },
    signing: { en: "Signing in...", es: "Iniciando sesión..." },
    tabs: {
      brand: { en: "Logo & Hero", es: "Logo y Portada" },
      texts: { en: "Texts & Services", es: "Textos y Servicios" },
      gallery: { en: "Gallery", es: "Galería" },
      leads: { en: "Quote Requests", es: "Solicitudes" }
    },
    save: { en: "Save changes", es: "Guardar cambios" },
    saved: { en: "Changes saved", es: "Cambios guardados" },
    logout: { en: "Log out", es: "Cerrar sesión" },
    viewSite: { en: "View site", es: "Ver sitio" },
    uploadLogo: { en: "Upload new logo", es: "Subir nuevo logo" },
    uploadImage: { en: "Upload image", es: "Subir imagen" },
    remove: { en: "Remove", es: "Quitar" },
    noLeads: { en: "No quote requests yet.", es: "Aún no hay solicitudes." },
    en: { en: "English text", es: "Texto en inglés" },
    es: { en: "Spanish text", es: "Texto en español" }
  }
};
